import { RebateCategoryEntity } from './RebateCategoryEntity';

export class VendorBuyingAgreementRebateCategoryEntity extends RebateCategoryEntity {
  constructor(entity?: VendorBuyingAgreementRebateCategoryEntity) {
    super(entity);
  }
}
